/**
 * TOBIE product scene: fallback for browsers without scroll-linked animation.
 *
 * Where `animation-timeline: view()` is supported the CSS does all the work and
 * this file does nothing. Elsewhere it writes `--k` on each scene, running from
 * -0.5 (scene entering at the bottom of the screen) to +0.5 (leaving at the
 * top), which the CSS turns into the same drift and turn.
 */
(() => {
  if (window.CSS && CSS.supports('animation-timeline: view()')) return;
  if (!window.TobieScroll || window.__tobieSceneFallback) return;
  window.__tobieSceneFallback = true;

  const scenes = () => Array.from(document.querySelectorAll('[data-tobie-scene]'));

  const update = () => {
    const vh = window.innerHeight;
    scenes().forEach((scene) => {
      const rect = scene.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return; // off screen: leave as is
      const k = (vh - rect.top) / (vh + rect.height) - 0.5;
      scene.style.setProperty('--k', Math.max(-0.5, Math.min(0.5, k)).toFixed(4));
    });
  };

  TobieScroll.subscribe(update);
  document.addEventListener('shopify:section:load', update);
})();
